export const CONST = {

  // BACKEND_URL: 'https://parklandback.osiztechnologies.in',
  BACKEND_URL:'https://prklndbkndlv.parklands.io',
  // BACKEND_URL: 'http://172.16.16.141:9131',
  chainId: '1225'

}